import { render, staticRenderFns } from "./ManureProcurement.vue?vue&type=template&id=506cbc6f&scoped=true&"
import script from "./ManureProcurement.vue?vue&type=script&lang=js&"
export * from "./ManureProcurement.vue?vue&type=script&lang=js&"
import style0 from "./ManureProcurement.vue?vue&type=style&index=0&id=506cbc6f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506cbc6f",
  null
  
)

export default component.exports